module.exports = __webpack_public_path__ + "static/media/118.48fd37e8.jpg";